(function(){
    angular
        .module('appback')
        .directive('ngEnter', ngEnter);

        ngEnter.$inject = ['$timeout'];
        function ngEnter($timeout){
            return {
	            require: 'ngModel',
	            link: function(scope, element, attrs, ngModel) {
					element.bind("keydown keypress", function (event) {
						console.log(event);
			            if(event.which === 13) {
			                scope.$apply(function (){
			                    scope.$eval(attrs.ngEnter);
			                });
			 
			                event.preventDefault();
			            }
			        });	            
				}
        	}
        }
})();